import { categories, conditions, locations } from '../../../mocks/swapItems';

interface SearchFiltersProps {
  selectedCategory: string;
  setSelectedCategory: (value: string) => void;
  selectedCondition: string;
  setSelectedCondition: (value: string) => void;
  selectedLocation: string;
  setSelectedLocation: (value: string) => void;
  onClearFilters: () => void;
}

export default function SearchFilters({
  selectedCategory,
  setSelectedCategory,
  selectedCondition,
  setSelectedCondition,
  selectedLocation,
  setSelectedLocation,
  onClearFilters
}: SearchFiltersProps) {
  return (
    <div className="w-72 flex-shrink-0">
      <div className="bg-white rounded-xl border border-gray-200 p-6 sticky top-28">
        <div className="flex items-center justify-between mb-6">
          <h3 className="text-lg font-semibold text-gray-900">Filters</h3>
          <button
            onClick={onClearFilters}
            className="text-sm text-teal-600 hover:text-teal-700 font-medium whitespace-nowrap"
          >
            Clear all
          </button>
        </div>

        {/* Category Filter */}
        <div className="mb-6">
          <label className="block text-sm font-medium text-gray-900 mb-3">
            Category
          </label>
          <div className="space-y-2">
            {categories.map(cat => (
              <label
                key={cat}
                className="flex items-center gap-3 cursor-pointer group"
              >
                <input
                  type="radio"
                  name="category"
                  checked={selectedCategory === cat}
                  onChange={() => setSelectedCategory(cat)}
                  className="w-4 h-4 text-teal-500 border-gray-300 focus:ring-teal-500 cursor-pointer"
                />
                <span className="text-sm text-gray-700 group-hover:text-gray-900">
                  {cat}
                </span>
              </label>
            ))}
          </div>
        </div>

        {/* Condition Filter */}
        <div className="mb-6 pt-6 border-t border-gray-200">
          <label className="block text-sm font-medium text-gray-900 mb-3">
            Condition
          </label>
          <div className="space-y-2">
            {conditions.map(cond => (
              <label
                key={cond}
                className="flex items-center gap-3 cursor-pointer group"
              >
                <input
                  type="radio"
                  name="condition"
                  checked={selectedCondition === cond}
                  onChange={() => setSelectedCondition(cond)}
                  className="w-4 h-4 text-teal-500 border-gray-300 focus:ring-teal-500 cursor-pointer"
                />
                <span className="text-sm text-gray-700 group-hover:text-gray-900">
                  {cond}
                </span>
              </label>
            ))}
          </div>
        </div>

        {/* Location Filter */}
        <div className="pt-6 border-t border-gray-200">
          <label className="block text-sm font-medium text-gray-900 mb-3">
            Location
          </label>
          <div className="space-y-2">
            {locations.map(loc => (
              <label
                key={loc}
                className="flex items-center gap-3 cursor-pointer group"
              >
                <input
                  type="radio"
                  name="location"
                  checked={selectedLocation === loc}
                  onChange={() => setSelectedLocation(loc)}
                  className="w-4 h-4 text-teal-500 border-gray-300 focus:ring-teal-500 cursor-pointer"
                />
                <span className="text-sm text-gray-700 group-hover:text-gray-900">
                  {loc}
                </span>
              </label>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
